/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	17-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_interactions_firstload = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	/**
	None yet
	**/
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	this.onready = function() {
		
		/*
		Trigger: modal and popup preloader
		*/
		images.preload();
		modal.onready();
		popup.onready();
		form.onready();
		if(pollConnection === 1) { poll_connection.onready(); }
		
		/*
		Trigger: onready classes
		*/
		specific_mobilemenu.onready();
		specific_accordeon.onready();
		specific_language_switcher.onready();

		/*
		Snowfall and splash screen
		Snowfall and splash screen
		Snowfall and splash screen
		Snowfall and splash screen
		*/
		$('.splash').snowfall({
			round		: true,
			minSize		: 5, 
			maxSize		: 8,
			flakeCount 	: 20
		});

		/*
		*/
		setTimeout(function() {

			$('.loading').animate({
					opacity:1
			},300);

			setTimeout(function() {
				$('.loading').addClass('active');
			},800);

			setTimeout(function() {

				$('.loading').animate({
					opacity:0
				},200);

				setTimeout(function() {

					var _height = $('.splash').height();

					$('.splash').animate({
						top:-_height
					},800,'easein');

					setTimeout(function() {
						$('.splash').hide();
					},800);

				},200);

			},3000);
			
		},0);

	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	// none
	
}).apply(specific_interactions_firstload); 